<template>
  <div class="row pt-4 pl-4 pr-4">
    <div class="col-sm-12 col-md-12 col-lg-4 mt-md-4 mt-sm-4">
      <div class="box-stat m-bottom-20">
        <div class="inner-stat-left bg-primary">
          <i class="fa fa-calendar"></i>
        </div>
        <div class="inner-stat-right">
          <div>
            <span class="stat">{{ user.leftPaidVacations ? user.leftPaidVacations.toFixed() : 0 }}</span><br/>
            <span>Solde de jours de congés disponibles</span>
          </div>
        </div>
      </div>
    </div>
    <div class="col-sm-12 col-md-12 col-lg-4 mt-md-4 mt-sm-4">
      <div class="box-stat m-bottom-20">
        <div class="inner-stat-left bg-success">
          <i class="fa fa-hourglass-start"></i>
        </div>
        <div class="inner-stat-right">
          <div>
            <span class="stat">{{ user.freeHoursAvailable || 0 }}</span><br/>
            <span>Heure(s) a recuperer</span>
          </div>
        </div>
      </div>
    </div>
    <div class="col-sm-12 col-md-12 col-lg-4 mt-md-4 mt-sm-4">
      <div class="box-stat m-bottom-20">
        <div class="inner-stat-left bg-warning">
          <i class="fa fa-tasks"></i>
        </div>
        <div class="inner-stat-right">
          <div>
            <span class="stat"> {{ pendingRequests }}</span><br/>
            <span>demande(s) en attente</span>
          </div>
        </div>
      </div>
    </div>
    <div class="col-sm-12 col-md-12 col-lg-4 mt-md-4 mt-sm-4">
      <div class="card">
        <div class="card-header">Mes notifications</div>
        <div class="card-body p-1">
          <div class="user-activity__item pr-3 py-3" v-for="(notification, index) in notifications" :key="index">
            <div
            :class="['user-activity__item__icon',  borderSelection(notification)]"
            v-html="iconFormat(notification)">
            </div>
            <div class="user-activity__item__content">
              <span class="text-light">{{ formatDate(notification.creationDate) }}</span>
              <p v-html="notification.message"></p>
            </div>
            <div class="user-activity__item__action ml-auto" v-if="notification.action">
              <button class="ml-auto btn btn-sm btn-white"
              @click="selectRoute(notification)">{{ btnText(notification) }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-sm-12 col-md-12 col-lg-8 mt-md-4 mt-sm-4">
      <div class="card">
        <div>
          <personal-tasks
           :overview="true"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TimeUtils from '../utils/TimeUtils';
import notificationsModel from '../data/notifications/notifications';
import PersonalTasks from '../views/Tasks/PersonalTasks';

export default {
  name: 'Index',
  components: {
    PersonalTasks,
  },
  data() {
    return {
      pendingRequests: 0,
    };
  },
  computed: {
    user() {
      return this.$store.state.user.informations;
    },
    notifications() {
      const notifications = this.$store.state.user.notifications.slice(0, 5);
      return notifications;
    },
  },
 async  mounted()  {
    this.fetchPendingRequests();
    const oldInfo=this.$store.state.user.informations
    const res=await this.$services.user.getUserData(this.$store.state.user.informations.reference)
    const information=res.data
    information.token=oldInfo.token
    await this.$store.dispatch('loginUser', information);
  },
  methods: {
    async fetchPendingRequests() {
      if (!this.user.reference) {
        setTimeout(() => {
          this.fetchPendingRequests();
        }, 100);
      } else {
        const { data } = await this.$services.absenceRequest.findAll({ userReference: this.user.reference, status: 'exists|0' });
        this.pendingRequests = data.length;
      }
    },
    formatDate(date) {
      return TimeUtils.formatDateTime(date);
    },
    borderSelection(notification) {
      if (notification.action && notification.status == 'PENDING') {
        return 'border-warning';
      } else if (notification.action && notification.status == 'ACCEPTED') {
        return 'border-success';
      }

      return 'border-light';
    },

    iconFormat(notification) {
      return notification.absenceId && notification.status != 'PENDING' ?
        notificationsModel.ACTION_PERFORMED.icon :
        notificationsModel[notification.type].icon;
    },

    titleFormat(notification) {
      return notification.absenceId && notification.status != 'PENDING' ?
        notificationsModel.ACTION_PERFORMED.title :
        notificationsModel[notification.type].title;
    },

    btnText(notification) {
      return notification.type == 'TASK' ? 'Tâche ouverte' : 'Voir la demande';
    },

    selectRoute(notification) {
      let route = '';
      if (notification.type == 'TASK') {
        route = notification.taskCreatedBy == this.user.reference ?
          `/tasks/${notification.action}` :
          `/personalTasks/${notification.action}`;
      } else {
        route = notification.action;
      }
      this.$router.push(route);
    },
  },
};
</script>

<style lang="scss">
.box-stat {
  border-radius: 5px;
  -webkit-box-shadow: 0px 0px 6px 0px rgba(0,0,0,0.16);
  -moz-box-shadow: 0px 0px 6px 0px rgba(0,0,0,0.16);
  box-shadow: 0px 0px 6px 0px rgba(0,0,0,0.16);
  display: flex;
  height: 140px;
  background-color: white;
  .inner-stat-left {
    flex-basis: 30%;
    padding: 15px;
    color: white;
    font-size: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .inner-stat-right {
    flex-basis: 70%;
    font-weight: 200;
    padding: 15px;
    display: flex;
    align-items: center;
    font-size: 19px;
    .stat {
      font-size: 28px;
      font-weight: 600;
    }
  }
}
.m-bottom-20 {
  @media (max-width: 767px) {
    margin-bottom: 25px;
  }
}
</style>
